module.exports = __webpack_public_path__ + "static/iosevka-bold.2e3a515f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/data/fonts/iosevka-bold.woff
// module id = 316
// module chunks = 79611799117203